import { render } from "./HealthnSafety.vue?vue&type=template&id=c6d88d94&scoped=true"
import script from "./HealthnSafety.vue?vue&type=script&lang=js"
export * from "./HealthnSafety.vue?vue&type=script&lang=js"

import "./HealthnSafety.vue?vue&type=style&index=0&id=c6d88d94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6d88d94"]])

export default __exports__